import { useSelector } from 'react-redux'
import { RootState } from '@AppState/redux-store'
import { Button } from '@radix-ui/themes'

export const NewVersionBanner = () => {
  const { initialVersion, currentVersion } = useSelector((state: RootState) => state.appVersion)
  const hasNewVersion =
    initialVersion !== null && currentVersion !== null && initialVersion !== currentVersion

  if (!hasNewVersion) {
    return null
  }

  return (
    <div className="new-version-banner">
      <span>A new version is available.</span>
      <Button size="1" onClick={() => window.location.reload()} style={{ cursor: 'pointer' }}>
        Refresh
      </Button>
    </div>
  )
}
